import React from "react"
import { useLingui } from "@lingui/react"
import * as O from "fp-ts/Option"
import * as F from "fp-ts/function"
import { t } from "@lingui/macro"
import { useECommerceMachine } from "../../../app-core/_common/machines/machines-context"
import {
    maybeSelectedSuiteCategory,
    SuiteCategoriesState,
    useSuiteCategoriesReadModel,
} from "../../../app-core/v3/_common/machines/suite-categories-machine"
import { stringIsPresent } from "../../../app-core/_common/checks"
import { BookingSteps } from "../../../app-core/_common/steps/booking-steps"
import StepRecap from "./StepRecap"
import { formatGuestsAndFare, stepStatus } from "./steps-recap"

type Props = {
    activeStep: BookingSteps
}

const StepsRecapPriceConfigV3: React.FC<Props> = ({ activeStep }) => {
    const { _ } = useLingui()
    const [state] = useECommerceMachine()
    const [stateSCRM] = useSuiteCategoriesReadModel(state)

    const formattedGuests = formatGuestsAndFare(state)
    const formattedSuite = formatSuite(stateSCRM)

    return (
        <div>
            <dl>
                <StepRecap
                    label={_(t`Guests and Fare`)}
                    value={formattedGuests}
                    state={stepStatus(formattedGuests, activeStep == "fare")}
                    testId="fare"
                />
                <StepRecap
                    label={_(t`Suite Category`)}
                    value={formattedSuite}
                    state={stepStatus(formattedSuite, activeStep == "category")}
                    testId="suite-category"
                />
                <StepRecap
                    label={_(t`Receive quote`)}
                    value={undefined}
                    state={stepStatus(undefined, activeStep == "send-quote")}
                    testId="send-quote"
                />
            </dl>
        </div>
    )
}

const formatSuite = (stateSCRM: SuiteCategoriesState) => {
    const suiteInfo = F.pipe(
        maybeSelectedSuiteCategory(stateSCRM),
        O.fold(
            () => undefined,
            (selectedSuiteCategory) => ({
                suiteName: selectedSuiteCategory.content.card.title,
                availability: selectedSuiteCategory.price.availability,
            }),
        ),
    )

    const suiteNumberOrGaranteed = suiteInfo?.availability == "guaranteed" ? ` (${t`Guaranteed category`})` : undefined
    return [suiteInfo?.suiteName, suiteNumberOrGaranteed].filter(stringIsPresent).join(" ")
}

export default StepsRecapPriceConfigV3
